import React, { useState } from 'react';
import Selection from 'src/components/Selection/Selection';
import { observer } from 'src/utils/mobx-react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { useAppStateContext } from 'src/AppState/AppState';
import { RaceWinnerColumnState } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/RaceWinner/RaceWinnerColumn.state';
import {
    RaceWinnerColumnTitle,
    RaceWinnerColumnWrapper
} from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/RaceWinner/RaceWrinnerColumn.style';
import { useAsObservableSource } from 'mobx-react-lite';
import { QuickPickViewState, sortSelections } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView.state';
import { DateTime } from 'src_common/utils/time/time';
import { TypeId } from 'src_common/common/websocket2/type';

export interface RaceWinnerColumnPropsType {
    userId: number,
    eventId: number,
    marketId: TypeId.MarketId,
    selected?: boolean,
    quickPickState: QuickPickViewState
}

export const RaceWinnerColumn = observer('RaceWinnerColumn', (propsIn: RaceWinnerColumnPropsType) => {
    const appState = useAppStateContext();
    const props = useAsObservableSource(propsIn);
    const [state] = useState(() => new RaceWinnerColumnState(props, appState));

    if (state.eventInCurrentColumn === null || state.marketInCurrentColumn === null || state.marketInCurrentColumn.templateId !== 'race-winner') {
        return null;
    }

    const currentMarket = state.marketInCurrentColumn;
    const competition = state.currentCompetition;

    if (competition === null) {
        return null;
    }

    const startTime = DateTime.from(state.eventInCurrentColumn.timeSettingsStartTime)?.tz(props.quickPickState.timeFilterState.timezone);

    const renderSelection = (selection: SelectionModel | null): JSX.Element | null => {
        if (selection === null) {
            return null;
        }

        return (
            <Selection
                key={selection.id}
                userId={props.userId}
                className='race-winner-column__selection'
                marketId={selection.marketId}
                selectionId={selection.id}
                allowShowSp={true}
                onHoverSelection={(): void => state.onHover(selection)}
            />
        );
    };

    return (
        <RaceWinnerColumnWrapper className={props.selected === true ? 'race-winner-column--selected' : ''} onMouseOver={state.onSelect}>
            <RaceWinnerColumnTitle onClick={state.onClickColumnTitle} className='race-winner-column__title'>
                {startTime?.format('HH:mm')}<br />
                <small>{competition.name}</small>
            </RaceWinnerColumnTitle>
            {
                sortSelections(currentMarket.selections, props.quickPickState.sort).map(selection => renderSelection(appState.websocketV2.getSelectionAndLoad(currentMarket.id, selection.id)))
            }
        </RaceWinnerColumnWrapper>
    );
});
